<template>
    <transition name="modal-fade">
        <div class="modal-backdrop" v-if="show">
            <div class="modal">
                
                <div class="modal-title">
                    {{title}}
                    <Icon :img="require('../../assets/icon-close-modal.png')" class="icon-close-modal" @click.native="close"/>
                </div>
                <div class="modal-body">
                    <div v-if="type != 'none'" class="modal-icon-wrap">
                        <img v-if="type=='success'" :src="require('../../assets/jiaoyiwanchen_icon.png')" class="modal-icon"/>
                        <img v-if="type=='error'" :src="require('../../assets/tishi_icon.png')" class="modal-icon"/>
                    </div>
                    
                    <slot name="body"></slot>
                </div>
                <div class="modal-footer">
                    <a href="javascript:;" class="primary-btn" @click="doButtonClick">{{button}}</a>
                    <slot name="footer"></slot>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    props: ['title', 'button', 'type'],
    data() {
        return {
            show: false
        }
    },
    methods: {
        display(){
            this.show = true;
        },
        close() {
            this.$emit('close')
            this.show = false;
        },
        doButtonClick(){
            this.$emit('confirm')
            this.close()
        }
    }
}
</script>
<style scoped lang="less">
.modal-backdrop {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0, 0, 0, .3);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 999;
}

.modal {
    background-color: #fff;
    box-shadow: 2px 2px 20px 1px;
    overflow-x: auto;
    display: flex;
    flex-direction: column;
    width: 78.2666vw;
    border-radius: 1vw;

    
}

.modal-title{
    font-size: 4.8vw;
    font-weight: bold;
    text-align: center;
    line-height: 15.47vw;
    color: #333;
    position: relative;

    .icon-close-modal{
        position: absolute;
        top: 6vw;
        right: 5.33vw;
        width: 3.2vw;
        height: 3.2vw;
    }
}

.modal-body {
    flex-wrap: wrap;
    justify-content: center;
    padding: 6.9333vw 0;
    font-size: 4.266666vw;
    color: #3c3c3c;
    text-align: center;
    line-height: 1.8em;
    width: 90%;
    margin: 0 auto;

    .modal-icon-wrap{
        margin-bottom: 2vw;
        .modal-icon{
            display: block;
            width: 20vw;
            height: 20vw;
            margin: 0 auto;
            
        }
    }

    
    
    p {
        width: 100%;
        text-align: center;
        margin: 0;
    }
    p:last-child {
        color: #c6c6c6;
        margin-top: 2.933333vw;
    }
}

.modal-footer {
    text-align: center;
    padding-bottom: 2.67vw;
    .primary-btn{
        display: block;
        width: 90%;
        margin: 0 auto;
        font-size: 4.53vw;
        text-align: center;
        color: white;
        border-radius: 0.8vw;
        line-height: 13.33vw;
        background-image: linear-gradient(to right, #FF4D4C, #FF6A4C);
    }
}

.btn-close {
    border: none 0;
    font-size: 20px;
    padding: 20px;
    cursor: pointer;
    font-weight: bold;
    color: #4aae9b;
    background-color: transparent;
}

.btn-green {
    color: #fff;
    background-color: #4aae9b;
    border: 1px solid #4aae9b;
    border-radius: 2px;
}

.modal-fade-enter,
.modal-fade-leave-active {
    opacity: 0;
}

.modal-fade-enter-active,
.modal-fade-leave-active {
    transition: opacity .2s ease
}
</style>




// WEBPACK FOOTER //
// src/components/common/Dialog.vue